const TRUTHY = new Set(['1', 'true', 'yes', 'on', 'enabled']);
const FALSY = new Set(['0', 'false', 'no', 'off', 'disabled']);

export function parseBooleanEnvFlag(value, fallback = false) {
  if (value === undefined || value === null || value === '') return fallback;
  const normalized = String(value).trim().toLowerCase();
  if (TRUTHY.has(normalized)) return true;
  if (FALSY.has(normalized)) return false;
  return fallback;
}

export function getSeoRuntimeFlags(env = (typeof process !== 'undefined' ? process.env : {})) {
  const seoRuntimeEnabled = parseBooleanEnvFlag(env.REACT_APP_SEO_RUNTIME_ENABLED, true);
  const metadataEnabled = parseBooleanEnvFlag(env.REACT_APP_SEO_METADATA_ENABLED, seoRuntimeEnabled);
  const schemaEnabled = parseBooleanEnvFlag(env.REACT_APP_SEO_SCHEMA_ENABLED, seoRuntimeEnabled);

  return {
    seoRuntimeEnabled,
    metadataEnabled,
    schemaEnabled,
  };
}

const runtimeFlagsCore = {
  parseBooleanEnvFlag,
  getSeoRuntimeFlags,
};

export default runtimeFlagsCore;
